import { Container } from "@remo-co/ui-core/src/components/Container";
import { IEvent } from "../types";
import EventListItem from "./components/EventListItem";
import "./EventList.scss";
import { useStyles } from "./EventListStyles";

interface Props {
  events: IEvent[];
  editable?: boolean;
  ended?: boolean;
  refetch?: () => void;
}

const EventList = ({ events, editable, ended, refetch }: Props) => {
  const styles = useStyles();

  return (
    <Container className={styles.root} maxWidth="xl">
      {events?.length &&
        events.map((event: IEvent) => (
          <div key={event.id}>
            <EventListItem
              event={event}
              editable={editable}
              ended={ended}
              refetch={refetch}
            />
          </div>
        ))}
    </Container>
  );
};

export default EventList;
